import { NAV_FAQ, NAV_HOME, NAV_NDES_CREATE, NAV_RELATIVE_NDES_BASIC_DETAILS } from '../../../constants';

const algoliaSearchData = [
  {
    'title': 'Home',
    'url': NAV_HOME
  },
  {
    'title': 'Add new NDE',
    'url': NAV_NDES_CREATE + NAV_RELATIVE_NDES_BASIC_DETAILS
  },
  {
    'title': 'Submit my experience',
    'url': NAV_NDES_CREATE + NAV_RELATIVE_NDES_BASIC_DETAILS
  },
  {
    'title': 'View FAQs',
    'url': NAV_FAQ
  }
];

export default algoliaSearchData;
